export enum PeriodOfTime {
  RANGE,
  LIMITED,
  FOREVER
}

